module.exports = __webpack_public_path__ + "static/RootSans-3Light-e21bbd8c890ea5231886474ad99489c0.woff";